// extracted by mini-css-extract-plugin
export default {"title":"NotificationDrawer_title__OYtCy","text":"NotificationDrawer_text__xn0h-"};